import React from 'react';
import NewlaneTutorialsForm from '@components/newlane-tutorials/NewlaneTutorialsForm';
import withNewlaneTutorials from '@hoc/withNewlaneTutorials';
import { useGetCurrentUserQuery } from '@teachur/http-client';
interface EditNewlaneTutorialsProps {
  newlaneTutorial: NewlaneTutorials;
}

const EditNewlaneTutorials: React.FC<EditNewlaneTutorialsProps> = ({ newlaneTutorial }) => {
  const { data: user } = useGetCurrentUserQuery();

  if (!user) {
    return null;
  }

  return <NewlaneTutorialsForm newlaneTutorial={newlaneTutorial} />;
};

const ConnectedEditNewlaneTutorials = withNewlaneTutorials(EditNewlaneTutorials);

const Page = () => <ConnectedEditNewlaneTutorials />;

export default Page;
